var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("频繁访问的配置")]),_c('p',[_vm._v("频繁访问的配置存储在 REDIS 中，调用性能极高。点击名称后面的 URL 图标可直接复制完整的 URL 调用。")])])])])
}]

export { render, staticRenderFns }